import { render, staticRenderFns } from "./Studio.vue?vue&type=template&id=34b5f17c&scoped=true"
import script from "./Studio.vue?vue&type=script&lang=ts"
export * from "./Studio.vue?vue&type=script&lang=ts"
import style0 from "./Studio.vue?vue&type=style&index=0&id=34b5f17c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.41_css-loader@6.11.0_webpack@5.109.2_clean-css_2948e68b94b5de989bd17d5ad2285242/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b5f17c",
  null
  
)

export default component.exports